interface UseEyeDropperOptions {
  onActiveChange?: (active: boolean) => void;
  onPick: (hexColor: string) => void;
}

/** Owns browser EyeDropper support, cancellation, and active-state reporting. */
export function useEyeDropper({ onActiveChange, onPick }: UseEyeDropperOptions) {
  const supported = Boolean(window.EyeDropper);

  async function pickColor() {
    const EyeDropper = window.EyeDropper;
    if (!EyeDropper) return;

    onActiveChange?.(true);
    try {
      const { sRGBHex } = await new EyeDropper().open();
      onPick(sRGBHex);
    } catch {
      // Native cancellation is not a color change.
    } finally {
      onActiveChange?.(false);
    }
  }

  return { pickColor, supported };
}
